import whitelabelConfig from '../../../whitelabel.config.js';

export const API = process.env.VUE_APP_API;

export const whiteLabel = whitelabelConfig[process.env.VUE_APP_BRAND];


// console.log(whiteLabel);
// console.log(process.env.VUE_APP_BRAND);
